import {PROVIDER_FLAGS} from '@Constants/index.constants.js';

export const PreviewProposalState = {
	url: '/proposal/:consultationId/:proposalId?showBack',
	title: 'Proposal Preview',
	// proposalId is dynamic so the v2 proposal tabs can swap proposals in place: the URL and
	// history update without re-entering the state or re-resolving providerFlags. v1 reads
	// the param once on init and never re-navigates here, so this is inert for it.
	params: {consultationId: null, proposalId: {value: null, dynamic: true}, showBack: null},
	// One state, one URL: the v2 provider flag decides which component renders, so both
	// versions live behind the same path. lazyLoad resolves the flag before importing, to
	// pull only the chunk that will actually render, and shares that lookup with the
	// providerFlags resolve below so the two cannot disagree.
	templateProvider: [
		'providerFlags',
		providerFlags =>
			providerFlags?.[PROVIDER_FLAGS.PRESENTATION_V2]
				? '<preview-proposal-v2 provider-flags="$resolve.providerFlags"></preview-proposal-v2>'
				: '<preview-proposal provider-flags="$resolve.providerFlags"></preview-proposal>',
	],
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		const RoutesSvc = $transition$.injector().get('RoutesResolveSvc');
		return (
			RoutesSvc.getPresentationFlags({trans: $transition$})
				// a failed lookup imports the production page; the providerFlags resolve below
				// reports the failure, so it is not swallowed here
				.catch(() => ({}))
				.then(flags =>
					flags?.[PROVIDER_FLAGS.PRESENTATION_V2]
						? import(
								/* webpackChunkName: "previewProposalV2Mod" */
								'@Containers/preview-proposal-page/preview-proposal-v2.cmp.js'
							)
						: import(
								/* webpackChunkName: "previewProposalMod" */
								'@Containers/preview-proposal-page/preview-proposal.cmp.js'
							)
				)
				.then(res => $ocLazyLoad.load({name: res.default}))
				.catch(err => $log.error(err))
		);
	},
	resolve: [
		{
			token: 'canView',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.validateConsultationPrivate({status: 'presented', ...trans.params()}).catch(state =>
					trans.router.stateService.go(state.name, state.params)
				),
		},
		{
			token: 'providerFlags',
			policy: {when: 'LAZY'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) => RoutesSvc.getPresentationFlags({trans}),
		},
	],
};
